const TEAM_COLORS = {
  Blue: '#0000FF',
  Green: '#008000',
  Orange: '#FFA500',
  Purple: '#800080',
  Red: '#FF0000'
};

const dogTeamsInfo = [
    { 
      id: 3, 
      name: 'Red Team', 
      teamName: 'Crowd Pleasers', 
      color: 'Red', 
      description: 'Perfect for the social butterflies. If your dog loves making new friends and being the center of attention, join the Crowd Pleasers.', 
      logo: 'RedTeam.png' 
    },
    { 
      id: 1, 
      name: 'Green Team', 
      teamName: 'Dynamos', 
      color: 'Green', 
      description: 'For dogs full of energy and enthusiasm. If your dog can’t sit still and loves engaging in lively activities, join the Dynamos.', 
      logo: 'GreenTeam.png' 
    },
    { 
      id: 4, 
      name: 'Purple Team', 
      teamName: 'Sages', 
      color: 'Purple', 
      description: 'Perfect for the wise and observant. If your dog seems to understand everything and makes wise choices, align with the Sages.', 
      logo: 'PurpleTeam.png' 
    },
    { 
      id: 5, 
      name: 'Orange Team', 
      teamName: 'Adventurers', 
      color: 'Orange', 
      description: 'For the explorers who thrive on discovery. Perfect for dogs who love uncovering hidden spots and relish in the thrill of exploration.', 
      logo: 'OrangeTeam.png' 
    },
    { 
      id: 2, 
      name: 'Blue Team', 
      teamName: 'Guardians', 
      color: 'Blue', 
      description: 'Ideal for dogs who are natural protectors. If your dog is always alert and watching over their family, this is their team.', 
      logo: 'BlueTeam.png' 
    },
  ];

  
  export default dogTeamsInfo;